<template>
    <main class="gExperience">
    
      <h1 id="pTop">Detailed experience</h1>

      <div class="spinerParent" v-if="loading">
        <img src="../assets/spin.png" class="imgReverse" />
      </div>

      <div class="decontainer" id="meshMe" v-else>

        <ExperienceTemplate v-for="(experience, i) in experiences" :key="i" :experienceModel="experience" />

        <h2 v-if="!fetchErr" :style="{marginTop:'100px', marginBottom:'25px'}">Summary of my steps throughout the time</h2>
        <Timeline v-if="!fetchErr" />

        <fetchError @ready="catchReady($event)" :style="{display:fetchErr?'flex':'none'}" :Exception="fetchErr" />
        
      </div>
    </main>
</template>
  
<script>
  import Request from '../mixins/axiosRequest';

  import Timeline from './Timeline.vue';
  import fetchError from '../components/Small/fetchError.vue';
  import ExperienceTemplate from '../components/ExperienceFull.vue';
  import queryPalette from "../mixins/themeColor.js";
  
  export default {
    name: "Experience",
    title: "Experience - Nethanzêl's Showroom",
    components: {
      Timeline,
      fetchError,
      ExperienceTemplate
    },
    data() {
      return {
        loading: true,
        fetchErr: null,
        experiences: [],
        errTrigger: undefined
      }
    },
    mounted() {
      this.loading = true;
      this.getExperiences();
    },
    methods: {
      async getExperiences() {
        let data = await Request.axiosGet("/api/experience", this.client);
        if(data.status) {
          this.experiences = data.data;
        } else {
          this.fetchErr = data.data;
        }
        this.loading = false;
        this.meshApply();
      },
      meshApply() {
        queryPalette.generatePalette().then((Palette) => {
          document.querySelector("#meshMe").style.backgroundImage = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
          document.querySelector("#meshMe").style.backgroundImage += `,radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
          document.querySelector("#meshMe").style.backgroundImage += `,radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`;
        });
      },
      catchReady(evt) {
        if(evt && this.fetchErr) {
          return evt(this.fetchErr.message , this.fetchErr.name);
        }
      }
    }
  };
</script>
  
<style scoped lang="scss">

  @media (prefers-color-scheme: dark) {
    .decontainer {
      background-color: #fff;
    }
    h1 {
      color: #fff;
    }

    h1::after {
      border-bottom: 2px solid #fff;
    }
  }

  @media (prefers-color-scheme: light) {
    .decontainer {
      background-color: #d1d1d1;
    }

    h1 {
      color: #000;
    }

    h1::after {
      border-bottom: 2px solid #000;
    }
    .imgReverse {
      filter: invert(1);
    }
  }

  .gExperience {
    display: flex;
    flex-direction: column;
    cursor: default;
    max-width: 1366px;
    margin: 0 auto 0 auto;
    padding-top: 60px;
    color: #fff;
    min-height: 70vh;
    

  }
  
  .decontainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    padding-bottom: 30px;

    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;

    color: #000;
    min-height: 50vh;

    overflow: hidden;
  }

  .spinerParent {
    margin: auto 0 auto 0;
  }
  
  h1 {
    letter-spacing: 3px;
    text-align: center;
    width: 100%;
    cursor: default;
    z-index: 10;
    margin-bottom: 45px;
    margin-top: 25px;
    }

    h1::after {
        content: "";
        display: block;
        margin: 0 auto;
        width: 280px;
        margin-top: 10px;
    }
  
  h2 {
    font-size: 35px;
    letter-spacing: 2px;
    cursor: default;
  }
  
  @media screen and (max-width: 660px) {
    h1 {
      font-size: 65px;
      letter-spacing: 3px;
    }
  
    h2 {
      font-size: 30px;
      letter-spacing: 2px;
    }
  }
  
  @media screen and (max-width: 570px) {
    h1 {
      font-size: 55px;
      letter-spacing: 3px;
    }
  
    h2 {
      font-size: 25px;
      letter-spacing: 2px;
    }
  }
  
  @media screen and (max-width: 490px) {
    h1 {
      font-size: 45px;
      letter-spacing: 3px;
    }
  
    h2 {
      font-size: 20px;
      letter-spacing: 2px;
    }
  }
</style>
  